<template>
  <div class="wrapper">
    <modal-popup></modal-popup>
    <div v-if="loaderShow" class="loader"></div>
    <div>
      <phone-form
        :user = "user"
      ></phone-form>
    </div>
  </div>
</template>

<script>
import PhoneForm from "./PhoneForm.vue";
import ModalPopup from "../Modal/ModalPopup.vue";
import { checkToken } from "@/services/AuthService";
import { AUTH } from "@/constants.js";

export default {
  components: {
    PhoneForm,
    ModalPopup
  },
  data() {
    return {
      user: [],
      loaderShow: true,
    }
  },  
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.checkPhone(localStorage.getItem("authToken"));
    }, 3000)
  },
  methods: {
    checkPhone(token){
      checkToken(token)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.user = data.results;
          if (this.user[0].phone && this.user[0].phone !== '0') {
            window.location.href = AUTH.URL + this.$i18n.locale;
          }          
          this.loaderShow = false
        })
        .catch((err) => {    
          this.loaderShow = false;
          console.log(err) 
        })
    }     
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped></style>
